import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { PrinterIcon, GraduationCapIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
import { BookMockup } from './BookMockup';
const trust = [{
  icon: ZapIcon,
  label: 'Instant Digital Access'
}, {
  icon: PrinterIcon,
  label: 'Print at Home or School'
}, {
  icon: GraduationCapIcon,
  label: 'Grades 1–5'
}];
export function Hero() {
  const reduce = useReducedMotion();
  const rise = (delay: number) => ({
    initial: reduce ? {} : {
      opacity: 0,
      y: 14
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.28,
      delay,
      ease: [0.23, 1, 0.32, 1] as const
    }
  });
  return <section className="cube-grid relative overflow-hidden bg-navy-900" data-id="element-95" data-mp="s9gji7eh2ubv">
      <div aria-hidden="true" className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-brand-emerald/40 to-transparent" data-id="element-96" data-mp="nbez9j5b8oyt" />
      <div className="relative z-10 mx-auto grid w-full max-w-6xl gap-10 px-4 pb-14 pt-10 sm:px-6 sm:pb-20 sm:pt-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-14 lg:pb-24 lg:pt-20" data-id="element-97" data-mp="381xmf1kmf8br">
        <div className="text-center lg:text-left" data-id="element-98" data-mp="3o7bzdvq44lfk">
          <motion.p {...rise(0)} className="inline-flex items-center gap-2 border-2 border-brand-emerald/60 bg-brand-emerald/10 px-3 py-1.5 font-pixel text-[9px] uppercase leading-none tracking-[0.14em] text-brand-emerald sm:text-[11px]" data-id="element-99" data-mp="3o73p8bldju82">
            <span className="h-2 w-2 bg-brand-emerald" aria-hidden="true" data-id="element-100" data-mp="30gzw4y5tbcvb" />
            Grades 1–5 • 200+ Exercises • Print &amp; Play
          </motion.p>

          <motion.h1 {...rise(0.05)} className="mt-5 text-[34px] font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-[56px]" data-id="element-101" data-mp="2qjv7mrohv5bc">
            Math Practice They&rsquo;ll{' '}
            <span className="text-brand-emerald" data-id="element-102" data-mp="2hix0i0irehoj">Actually</span> Want to Finish.
          </motion.h1>

          <motion.p {...rise(0.1)} className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg lg:mx-0" style={{
          fontSize: "14px"
        }} data-id="element-103" data-mp="2ll0gn2gdiag5">
            Turn everyday math into short, pixel-style challenges that make it
            easier to start, more engaging to practice, and rewarding to
            complete.
          </motion.p>

          <motion.div {...rise(0.15)} className="mt-7 lg:hidden" data-id="element-104" data-mp="i9vrh5f8g2md">
            <BookMockup data-id="element-105" data-mp="degiaqs66uwa" />
          </motion.div>

          <motion.div {...rise(0.2)} className="mt-8" data-id="element-106" data-mp="1b0vzrskljsju">
            <a href="#offer" className="cta-pulse group inline-flex w-full items-center justify-center gap-2 border-b-4 border-[#b47a08] bg-brand-gold px-5 py-4 font-pixel text-[10px] uppercase leading-none tracking-[0.08em] text-navy-900 transition-[transform,background-color] duration-150 ease-out hover:bg-[#ffc23f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-cyan active:translate-y-[2px] sm:w-auto sm:px-6 sm:text-xs" data-id="element-107" data-mp="1b0du65c1o1z9">
              Get Instant Access
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-108" data-mp="1x9ujo7n357lu" />
            </a>
          </motion.div>

          <motion.ul {...rise(0.25)} className="mt-7 flex flex-col items-center gap-3 text-sm text-slate-300 sm:flex-row sm:flex-wrap sm:justify-center lg:justify-start" data-id="element-109" data-mp="2697m4gcskvx2">
            {trust.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2 whitespace-nowrap" data-id="element-110" data-mp="2kync3u4i0xbp">
                <Icon className="h-4 w-4 shrink-0 text-brand-cyan" aria-hidden="true" data-id="element-111" data-mp="2p0h7pnzu7b50" />
                <span data-id="element-112" data-mp="2oynzi49ksiuw">{label}</span>
              </li>)}
          </motion.ul>
        </div>

        <motion.div initial={reduce ? {} : {
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="hidden lg:block" data-id="element-113" data-mp="2tx7m86vztyob">
          <BookMockup data-id="element-114" data-mp="4a2uzlkb9c05" />
        </motion.div>
      </div>
    </section>;
}